import { CBCT_SectionOrientation } from '@/shared/api/protocol-ts/model/dto_asset_common_pb';
import type { FloatPoint3D } from '@/shared/api/protocol-ts/model/dto_common_geometry_pb';
import {
  ToothFullHeadMPRSliceView,
  ToothFullHeadMPRSliceView_SamplingMode,
} from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';
import type {
  FullHeadMPRProjection,
  FullHeadMPRSavedView,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

const point = (value: FloatPoint3D) => ({ x: value.X, y: value.Y, z: value.Z });

export const makeSavedFullHeadMprView = (
  view: ToothFullHeadMPRSliceView,
  { projection }: { projection?: FullHeadMPRProjection } = {},
): FullHeadMPRSavedView | null => {
  if (
    !view.CenterMm ||
    !view.UAxis ||
    !view.VAxis ||
    !view.Normal ||
    ![
      CBCT_SectionOrientation.SectionOrientationAxial,
      CBCT_SectionOrientation.SectionOrientationVestibuloOral,
      CBCT_SectionOrientation.SectionOrientationMesioDistal,
    ].includes(view.Orientation) ||
    ![
      ToothFullHeadMPRSliceView_SamplingMode.Native,
      ToothFullHeadMPRSliceView_SamplingMode.MeanSlab,
    ].includes(view.Sampling)
  ) {
    return null;
  }
  return {
    centerMm: point(view.CenterMm),
    heightMm: view.HeightMm,
    normal: point(view.Normal),
    projection:
      projection ??
      (view.Orientation === CBCT_SectionOrientation.SectionOrientationAxial
        ? 'axial'
        : view.Orientation ===
            CBCT_SectionOrientation.SectionOrientationVestibuloOral
          ? 'coronal'
          : 'sagittal'),
    sampleOffsetsMm: [...view.SampleOffsetsMm],
    sampling:
      view.Sampling === ToothFullHeadMPRSliceView_SamplingMode.Native
        ? 'native'
        : 'mean-slab',
    thicknessMm: view.ThicknessMm,
    uAxis: point(view.UAxis),
    vAxis: point(view.VAxis),
    volumeFileID: view.VolumeFileID,
    widthMm: view.WidthMm,
    window: { wc: view.WindowCenter, ww: view.WindowWidth },
  };
};
